import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DistrictApproval = () => {
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchRecords = async () => {
    try {
      const response = await axios.get('https://lionsdirectoryapi.emedha.in/auth/api/dist-signup'); // API should return all DistSignup entries
      setRecords(response.data || []);
    } catch (err) {
      console.error("Error loading DistSignup records:", err);
    }
  };

  useEffect(() => {
    fetchRecords();
  }, []);
const handleApprove = async (id) => {
  try {
    await axios.patch(`https://lionsdirectoryapi.emedha.in/auth/api/dist-signup/approve/${id}`);
    fetchRecords(); // Re-fetch updated list
  } catch (error) {
    console.error("Approval Error:", error);
  }
};

const handleReject = async (id) => {
  try {
    await axios.patch(`https://lionsdirectoryapi.emedha.in/auth/api/dist-signup/reject/${id}`);
    fetchRecords(); // Re-fetch updated list
  } catch (error) {
    console.error("Rejection Error:", error);
  }
};


  const handleDelete = async (id) => {
    if (!window.confirm("Delete this district sign-up?")) return;
    try {
      await axios.delete(`https://lionsdirectoryapi.emedha.in/auth/api/dist-signup/${id}`);
      fetchRecords();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete. Try again.");
    }
  };

  const filtered = records.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.mobile.includes(searchTerm) ||
    item.district.includes(searchTerm)
  );

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <h4  style={{ color: 'rgb(245, 170, 30)' }} >District Sign-Ups</h4>
        <input
          type="text"
          placeholder="Search by name, email, mobile, district"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="form-control w-50"
        />
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>District</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
      <tbody>
  {filtered.map((r, idx) => (
    <tr key={r.id}>
      <td>{idx + 1}</td>
      <td>{r.name}</td>
      <td>{r.email}</td>
      <td>{r.mobile}</td>
      <td>{r.district}</td>
      <td>
        {r.isApprove === 1 ? (
          <span className="text-success">Approved</span>
        ) : (
          <span className="text-warning">Pending</span>
        )}
      </td>
      <td>
        {r.isApprove === 0 ? (
          <button
            className="btn btn-success btn-sm me-2"
            onClick={() => handleApprove(r.id)}
          >
            Approve
          </button>
        ) : (
          <button
            className="btn btn-warning btn-sm me-2"
            onClick={() => handleReject(r.id)}
          >
            Reject
          </button>
        )}
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(r.id)}
        >
          Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>
      </table>


    </>
  );
};

export default DistrictApproval;
